import { z } from 'zod';
import { dateField } from '@shared/schemas';
import { EquipmentTypes } from './Equipment/EquipmentTypes';
import { baseAreaSchema } from './IBaseArea';
import { baseFloorSchema } from './IBaseFloor';

// Inline schema for equipment reporter (extends IBaseArea with additional fields)
const equipmentReporterSchema = baseAreaSchema.extend({
	tagId: z.string(),
	profession: z.string().nullable(),
	rssi: z.string(),
	timestamp: dateField,
	floorId: z.string(),
	floorNick: z.string(),
});

// Schemas (source of truth)
export const mergedEquipmentSchema = z.object({ ...baseAreaSchema.shape, ...baseFloorSchema.shape }).extend({
	_id: z.string().optional(),
	// IStaticEquipment fields
	company: z.string(),
	serialNumber: z.string(),
	name: z.string(),
	type: z.enum(EquipmentTypes),
	typeNick: z.string(),
	equipmentId: z.string(),
	projectId: z.string(),
	lastSeenDate: dateField,
	// IRawEquipment (IRawAnchor) fields
	uuid: z.string(),
	batteryLevel: z.string(),
	RSSI: z.string(),
	// IMergedEquipment own fields
	reporters: z.array(equipmentReporterSchema),
	unSureLocationCounter: z.number().optional(),
	// IMergedEquipmentView fields (stored in DB by LocationEngine)
	reporterTagIds: z.array(z.string()),
});

// Types (derived from schemas)
export type IMergedEquipment = z.infer<typeof mergedEquipmentSchema>;
